import { FC } from "react";
import Button from "../../../Button";
import { EPaymentMode } from "../StudentPaymentPane";
import useAuth from "../../../../hooks/useAuth";
import { useTranslation } from "react-i18next";

interface IProps {
  setAddPaymentVisible: (visible: boolean) => void;
  onSetPaymentMode: (mode: EPaymentMode) => void;
};

const PaymentButtons: FC<IProps> = ({
  setAddPaymentVisible,
  onSetPaymentMode,
}) => {
  const { writeAuthYn } = useAuth();
  const { t } = useTranslation();

  return (
    <div className="comm-btn__area right">
      <Button
        className="btn-basic pink-line"
        onClick={() => setAddPaymentVisible(true)}
        text={t('student.student.button7')}
        writeAuthYn={writeAuthYn}
      />
      <Button
        className="btn-basic pink-line"
        onClick={() => onSetPaymentMode(EPaymentMode.PaymentProcessing)}
        text={t('student.student.button8')}
        writeAuthYn={writeAuthYn}
      />
    </div>
  );
};

export default PaymentButtons;